import { useSpinButton } from "@react-aria/spinbutton";
import { useMessageFormatter, useNumberFormatter } from "@react-aria/i18n";
import { useFormattedTextField } from "@react-aria/textfield";
import { useFocus, useFocusWithin, useScrollWheel } from "@react-aria/interactions";
import { isAndroid, isIOS, isIPhone, mergeProps, useId } from "@react-aria/utils";
import { useCallback, useMemo, useState } from "react";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/ar-AE.json
var $f89057a954f93785840632a2bd0de992$exports = {};
$f89057a954f93785840632a2bd0de992$exports = JSON.parse("{\"decrease\":\"خفض {fieldLabel}\",\"increase\":\"زيادة {fieldLabel}\",\"numberField\":\"حقل رقمي\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/bg-BG.json
var $bb50c5271a0a6b3396a6ef14c033c253$exports = {};
$bb50c5271a0a6b3396a6ef14c033c253$exports = JSON.parse("{\"decrease\":\"Намаляване {fieldLabel}\",\"increase\":\"Усилване {fieldLabel}\",\"numberField\":\"Номер на полето\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/cs-CZ.json
var $c7ee156ca303bba86c91e97dcce197f9$exports = {};
$c7ee156ca303bba86c91e97dcce197f9$exports = JSON.parse("{\"decrease\":\"Snížit {fieldLabel}\",\"increase\":\"Zvýšit {fieldLabel}\",\"numberField\":\"Číselné pole\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/da-DK.json
var $cd783379a265aee2b5ba60bf401f59ee$exports = {};
$cd783379a265aee2b5ba60bf401f59ee$exports = JSON.parse("{\"decrease\":\"Reducer {fieldLabel}\",\"increase\":\"Øg {fieldLabel}\",\"numberField\":\"Talfelt\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/de-DE.json
var $bbb8b61a73a197f955e3a3324a7cdcb$exports = {};
$bbb8b61a73a197f955e3a3324a7cdcb$exports = JSON.parse("{\"decrease\":\"{fieldLabel} verringern\",\"increase\":\"{fieldLabel} erhöhen\",\"numberField\":\"Nummernfeld\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/el-GR.json
var $bb347c7d10469f1c9abd075c$exports = {};
$bb347c7d10469f1c9abd075c$exports = JSON.parse("{\"decrease\":\"Μείωση {fieldLabel}\",\"increase\":\"Αύξηση {fieldLabel}\",\"numberField\":\"Πεδίο αριθμού\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/en-US.json
var $caf821fb3707e7e853722ffa922d78c$exports = {};
$caf821fb3707e7e853722ffa922d78c$exports = JSON.parse("{\"decrease\":\"Decrease {fieldLabel}\",\"increase\":\"Increase {fieldLabel}\",\"numberField\":\"Number field\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/es-ES.json
var $f19046adfa8241d47f5e94851a12$exports = {};
$f19046adfa8241d47f5e94851a12$exports = JSON.parse("{\"decrease\":\"Reducir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo de número\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/et-EE.json
var $cd6deb9ec33040038f7fc83faa14b68$exports = {};
$cd6deb9ec33040038f7fc83faa14b68$exports = JSON.parse("{\"decrease\":\"Vähenda {fieldLabel}\",\"increase\":\"Suurenda {fieldLabel}\",\"numberField\":\"Numbri väli\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/fi-FI.json
var $e761fc0593563e081a2cc97ee7041bcb$exports = {};
$e761fc0593563e081a2cc97ee7041bcb$exports = JSON.parse("{\"decrease\":\"Vähennä {fieldLabel}\",\"increase\":\"Lisää {fieldLabel}\",\"numberField\":\"Numerokenttä\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/fr-FR.json
var $d89a323c79de575aa883e16d1ca9d076$exports = {};
$d89a323c79de575aa883e16d1ca9d076$exports = JSON.parse("{\"decrease\":\"Diminuer {fieldLabel}\",\"increase\":\"Augmenter {fieldLabel}\",\"numberField\":\"Champ de nombre\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/he-IL.json
var $c11023680875610f2a235956d155a$exports = {};
$c11023680875610f2a235956d155a$exports = JSON.parse("{\"decrease\":\"הקטן {fieldLabel}\",\"increase\":\"הגדל {fieldLabel}\",\"numberField\":\"שדה מספר\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/hr-HR.json
var $d599a7228f0a499531e4d20752ea8f$exports = {};
$d599a7228f0a499531e4d20752ea8f$exports = JSON.parse("{\"decrease\":\"Smanji {fieldLabel}\",\"increase\":\"Povećaj {fieldLabel}\",\"numberField\":\"Polje broja\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/hu-HU.json
var $c451c76e695fbc93833e53ffeed217fe$exports = {};
$c451c76e695fbc93833e53ffeed217fe$exports = JSON.parse("{\"decrease\":\"{fieldLabel} csökkentése\",\"increase\":\"{fieldLabel} növelése\",\"numberField\":\"Számmező\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/it-IT.json
var $ac70696c898389bc1e4a41767749b$exports = {};
$ac70696c898389bc1e4a41767749b$exports = JSON.parse("{\"decrease\":\"Riduci {fieldLabel}\",\"increase\":\"Aumenta {fieldLabel}\",\"numberField\":\"Campo numero\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/ja-JP.json
var $e8614d1bf3c7ac8137ef7dc1e94d93$exports = {};
$e8614d1bf3c7ac8137ef7dc1e94d93$exports = JSON.parse("{\"decrease\":\"{fieldLabel}を縮小\",\"increase\":\"{fieldLabel}を拡大\",\"numberField\":\"数値フィールド\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/ko-KR.json
var $b6b01c4c7f0d49342efb092caaed0$exports = {};
$b6b01c4c7f0d49342efb092caaed0$exports = JSON.parse("{\"decrease\":\"{fieldLabel} 감소\",\"increase\":\"{fieldLabel} 증가\",\"numberField\":\"번호 필드\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/lt-LT.json
var $d638445b5e6b60023a71c9efadccdcef$exports = {};
$d638445b5e6b60023a71c9efadccdcef$exports = JSON.parse("{\"decrease\":\"Sumažinti {fieldLabel}\",\"increase\":\"Padidinti {fieldLabel}\",\"numberField\":\"Numerio laukas\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/lv-LV.json
var $ae944d129bd36acc712963ce76c5a6$exports = {};
$ae944d129bd36acc712963ce76c5a6$exports = JSON.parse("{\"decrease\":\"Samazināšana {fieldLabel}\",\"increase\":\"Palielināšana {fieldLabel}\",\"numberField\":\"Skaitļu lauks\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/nb-NO.json
var $fad02fd729fa21c4cb26b8991$exports = {};
$fad02fd729fa21c4cb26b8991$exports = JSON.parse("{\"decrease\":\"Reduser {fieldLabel}\",\"increase\":\"Øk {fieldLabel}\",\"numberField\":\"Tallfelt\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/nl-NL.json
var $a1b086ccbc84dac08828b450ab346e6b$exports = {};
$a1b086ccbc84dac08828b450ab346e6b$exports = JSON.parse("{\"decrease\":\"{fieldLabel} verlagen\",\"increase\":\"{fieldLabel} verhogen\",\"numberField\":\"Getalveld\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/pl-PL.json
var $f4f165d5301df9e649c89122963039$exports = {};
$f4f165d5301df9e649c89122963039$exports = JSON.parse("{\"decrease\":\"Zmniejsz {fieldLabel}\",\"increase\":\"Zwiększ {fieldLabel}\",\"numberField\":\"Pole numeru\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/pt-BR.json
var $fe0b8e68375cfc597750ced5645ea0a5$exports = {};
$fe0b8e68375cfc597750ced5645ea0a5$exports = JSON.parse("{\"decrease\":\"Diminuir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo de número\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/pt-PT.json
var $d96a9e5abb099c9ed641e5527cd144d$exports = {};
$d96a9e5abb099c9ed641e5527cd144d$exports = JSON.parse("{\"decrease\":\"Diminuir {fieldLabel}\",\"increase\":\"Aumentar {fieldLabel}\",\"numberField\":\"Campo numérico\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/ro-RO.json
var $f23e5e9ed3cd163f6d4f$exports = {};
$f23e5e9ed3cd163f6d4f$exports = JSON.parse("{\"decrease\":\"Scădere {fieldLabel}\",\"increase\":\"Creștere {fieldLabel}\",\"numberField\":\"Câmp numeric\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/ru-RU.json
var $ba31f445852bdf6da5f6cee901de9e44$exports = {};
$ba31f445852bdf6da5f6cee901de9e44$exports = JSON.parse("{\"decrease\":\"Уменьшение {fieldLabel}\",\"increase\":\"Увеличение {fieldLabel}\",\"numberField\":\"Числовое поле\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/sk-SK.json
var $f074b7cb6f9b1d1da81300d33c7f$exports = {};
$f074b7cb6f9b1d1da81300d33c7f$exports = JSON.parse("{\"decrease\":\"Znížiť {fieldLabel}\",\"increase\":\"Zvýšiť {fieldLabel}\",\"numberField\":\"Číselné pole\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/sl-SI.json
var $ff43b1107f031fbe74acdc9486f9636$exports = {};
$ff43b1107f031fbe74acdc9486f9636$exports = JSON.parse("{\"decrease\":\"Upadati {fieldLabel}\",\"increase\":\"Povečajte {fieldLabel}\",\"numberField\":\"Številčno polje\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/sr-SP.json
var $fff5c3362790a28269c613597129b4f$exports = {};
$fff5c3362790a28269c613597129b4f$exports = JSON.parse("{\"decrease\":\"Decrease {fieldLabel}\",\"increase\":\"Increase {fieldLabel}\",\"numberField\":\"Number field\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/sv-SE.json
var $aaa4a2eb77b3ce43c303d74b0aca1bec$exports = {};
$aaa4a2eb77b3ce43c303d74b0aca1bec$exports = JSON.parse("{\"decrease\":\"Minska {fieldLabel}\",\"increase\":\"Öka {fieldLabel}\",\"numberField\":\"Nummerfält\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/tr-TR.json
var $de32d7b192940776e4915f1$exports = {};
$de32d7b192940776e4915f1$exports = JSON.parse("{\"decrease\":\"{fieldLabel} azalt\",\"increase\":\"{fieldLabel} arttır\",\"numberField\":\"Sayı alanı\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/uk-UA.json
var $f30e570c86296056a772413e859b$exports = {};
$f30e570c86296056a772413e859b$exports = JSON.parse("{\"decrease\":\"Зменшити {fieldLabel}\",\"increase\":\"Збільшити {fieldLabel}\",\"numberField\":\"Поле номера\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/zh-CN.json
var $cc0c90a7c4ab50ec660db43ccb665c3c$exports = {};
$cc0c90a7c4ab50ec660db43ccb665c3c$exports = JSON.parse("{\"decrease\":\"降低 {fieldLabel}\",\"increase\":\"提高 {fieldLabel}\",\"numberField\":\"数字字段\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/numberfield/intl/zh-TW.json
var $c2596f5e9c6c63e22526e4ccf47b$exports = {};
$c2596f5e9c6c63e22526e4ccf47b$exports = JSON.parse("{\"decrease\":\"縮小 {fieldLabel}\",\"increase\":\"放大 {fieldLabel}\",\"numberField\":\"數字欄位\"}");
// @ts-ignore
const $b40e566e8b7705a138eb78aae622eee$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($f89057a954f93785840632a2bd0de992$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($bb50c5271a0a6b3396a6ef14c033c253$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($c7ee156ca303bba86c91e97dcce197f9$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($cd783379a265aee2b5ba60bf401f59ee$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($bbb8b61a73a197f955e3a3324a7cdcb$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($bb347c7d10469f1c9abd075c$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($caf821fb3707e7e853722ffa922d78c$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($f19046adfa8241d47f5e94851a12$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($cd6deb9ec33040038f7fc83faa14b68$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($e761fc0593563e081a2cc97ee7041bcb$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($d89a323c79de575aa883e16d1ca9d076$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($c11023680875610f2a235956d155a$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($d599a7228f0a499531e4d20752ea8f$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($c451c76e695fbc93833e53ffeed217fe$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($ac70696c898389bc1e4a41767749b$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($e8614d1bf3c7ac8137ef7dc1e94d93$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($b6b01c4c7f0d49342efb092caaed0$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($d638445b5e6b60023a71c9efadccdcef$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($ae944d129bd36acc712963ce76c5a6$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($fad02fd729fa21c4cb26b8991$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($a1b086ccbc84dac08828b450ab346e6b$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($f4f165d5301df9e649c89122963039$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($fe0b8e68375cfc597750ced5645ea0a5$exports).default,
  "pt-PT": _babelRuntimeHelpersEsmInteropRequireDefault($d96a9e5abb099c9ed641e5527cd144d$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($f23e5e9ed3cd163f6d4f$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($ba31f445852bdf6da5f6cee901de9e44$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($f074b7cb6f9b1d1da81300d33c7f$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($ff43b1107f031fbe74acdc9486f9636$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($fff5c3362790a28269c613597129b4f$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($aaa4a2eb77b3ce43c303d74b0aca1bec$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($de32d7b192940776e4915f1$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($f30e570c86296056a772413e859b$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($cc0c90a7c4ab50ec660db43ccb665c3c$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($c2596f5e9c6c63e22526e4ccf47b$exports).default
};

/**
 * Provides the behavior and accessibility implementation for a number field component.
 * Number fields allow users to enter a number, and increment or decrement the value using stepper buttons.
 */
export function useNumberField(props, state, inputRef) {
  let {
    id,
    decrementAriaLabel,
    incrementAriaLabel,
    isDisabled,
    isReadOnly,
    isRequired,
    minValue,
    maxValue,
    autoFocus,
    validationState,
    label,
    formatOptions,
    onBlur,
    onFocus,
    onFocusChange,
    onKeyDown,
    onKeyUp,
    description,
    errorMessage
  } = props;
  let {
    increment,
    incrementToMax,
    decrement,
    decrementToMin,
    numberValue,
    commit
  } = state;
  const formatMessage = useMessageFormatter($b40e566e8b7705a138eb78aae622eee$var$intlMessages);
  let inputId = useId(id);
  let {
    focusProps
  } = useFocus({
    onBlur: () => {
      // Set input value to normalized valid value
      commit();
    }
  });
  let {
    spinButtonProps,
    incrementButtonProps: incButtonProps,
    decrementButtonProps: decButtonProps
  } = useSpinButton({
    isDisabled,
    isReadOnly,
    isRequired,
    maxValue,
    minValue,
    onIncrement: increment,
    onIncrementToMax: incrementToMax,
    onDecrement: decrement,
    onDecrementToMin: decrementToMin,
    value: numberValue,
    textValue: state.inputValue
  });
  let [focusWithin, setFocusWithin] = useState(false);
  let {
    focusWithinProps
  } = useFocusWithin({
    isDisabled,
    onFocusWithinChange: setFocusWithin
  });
  let onWheel = useCallback(e => {
    // if on a trackpad, users can scroll in both X and Y at once, check the magnitude of the change
    // if it's mostly in the X direction, then just return, the user probably doesn't mean to inc/dec
    // this isn't perfect, events come in fast with small deltas and a part of the scroll may give a false indication
    // especially if the user is scrolling near 45deg
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) {
      return;
    }

    if (e.deltaY > 0) {
      increment();
    } else if (e.deltaY < 0) {
      decrement();
    }
  }, [decrement, increment]); // If the input isn't supposed to receive input, disable scrolling.

  let scrollingDisabled = isDisabled || isReadOnly || !focusWithin;
  useScrollWheel({
    onScroll: onWheel,
    isDisabled: scrollingDisabled
  }, inputRef); // The inputMode attribute influences the software keyboard that is shown on touch devices.
  // Browsers and operating systems are quite inconsistent about what keys are available, however.
  // We choose between numeric and decimal based on whether we allow negative and fractional numbers,
  // and based on testing on various devices to determine what keys are available in each inputMode.

  let numberFormatter = useNumberFormatter(formatOptions);
  let intlOptions = useMemo(() => numberFormatter.resolvedOptions(), [numberFormatter]);
  let hasDecimals = intlOptions.maximumFractionDigits > 0;
  let hasNegative = isNaN(state.minValue) || state.minValue < 0;
  let inputMode = 'numeric';

  if (isIPhone()) {
    // iPhone doesn't have a minus sign in either numeric or decimal.
    // Note this is only for iPhone, not iPad, which always has both
    // minus and decimal in numeric.
    if (hasNegative) {
      inputMode = 'text';
    } else if (hasDecimals) {
      inputMode = 'decimal';
    }
  } else if (isAndroid()) {
    // Android numeric has both a decimal point and minus key.
    // decimal does not have a minus key.
    if (hasNegative) {
      inputMode = 'numeric';
    } else if (hasDecimals) {
      inputMode = 'decimal';
    }
  }

  let onChange = value => {
    state.setInputValue(value);
  };

  let {
    labelProps,
    inputProps: textFieldProps,
    descriptionProps,
    errorMessageProps
  } = useFormattedTextField({
    label,
    autoFocus,
    isDisabled,
    isReadOnly,
    isRequired,
    validationState,
    value: state.inputValue,
    autoComplete: 'off',
    'aria-label': props['aria-label'] || null,
    'aria-labelledby': props['aria-labelledby'] || null,
    id: inputId,
    type: 'text',
    // Can't use type="number" because then we can't have things like $ in the field.
    inputMode,
    onChange,
    onBlur,
    onFocus,
    onFocusChange,
    onKeyDown,
    onKeyUp,
    description,
    errorMessage
  }, state, inputRef);
  let inputProps = mergeProps(spinButtonProps, textFieldProps, focusProps, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    'aria-roledescription': !isIOS() ? formatMessage('numberField') : null,
    'aria-valuemax': null,
    'aria-valuemin': null,
    'aria-valuenow': null,
    'aria-valuetext': null,
    autoCorrect: 'off',
    spellCheck: 'false'
  });

  let onButtonPressStart = e => {
    // If focus is already on the input, keep it there so we don't hide the
    // software keyboard when tapping the increment/decrement buttons.
    if (document.activeElement === inputRef.current) {
      return;
    } // Otherwise, when using a mouse, move focus to the input.
    // On touch, or with a screen reader, focus the button so that the software
    // keyboard does not appear and the screen reader cursor is not moved off the button.


    if (e.pointerType === 'mouse') {
      inputRef.current.focus();
    } else {
      e.target.focus();
    }
  }; // Determine the label for the increment and decrement buttons. There are 4 cases:
  //
  // 1. With a visible label that is a string: aria-label: `Increase ${props.label}`
  // 2. With a visible label that is JSX: aria-label: 'Increase', aria-labelledby: '${incrementId} ${labelId}'
  // 3. With an aria-label: aria-label: `Increase ${props['aria-label']}`
  // 4. With an aria-labelledby: aria-label: 'Increase', aria-labelledby: `${incrementId} ${props['aria-labelledby']}`
  //
  // (1) and (2) could possibly be combined and both use aria-labelledby. However, placing the label in
  // the aria-label string rather than using aria-labelledby gives more flexibility to translators to change
  // the order or add additional words around the label if needed.


  let fieldLabel = props['aria-label'] || (typeof props.label === 'string' ? props.label : '');
  let ariaLabelledby;

  if (!fieldLabel) {
    ariaLabelledby = props.label != null ? labelProps.id : props['aria-labelledby'];
  }

  let incrementId = useId();
  let decrementId = useId();
  let incrementButtonProps = mergeProps(incButtonProps, {
    'aria-label': incrementAriaLabel || formatMessage('increase', {
      fieldLabel
    }).trim(),
    id: ariaLabelledby && !incrementAriaLabel ? incrementId : null,
    'aria-labelledby': ariaLabelledby && !incrementAriaLabel ? incrementId + " " + ariaLabelledby : null,
    'aria-controls': inputId,
    excludeFromTabOrder: true,
    preventFocusOnPress: true,
    isDisabled: !state.canIncrement,
    onPressStart: onButtonPressStart
  });
  let decrementButtonProps = mergeProps(decButtonProps, {
    'aria-label': decrementAriaLabel || formatMessage('decrease', {
      fieldLabel
    }).trim(),
    id: ariaLabelledby && !decrementAriaLabel ? decrementId : null,
    'aria-labelledby': ariaLabelledby && !decrementAriaLabel ? decrementId + " " + ariaLabelledby : null,
    'aria-controls': inputId,
    excludeFromTabOrder: true,
    preventFocusOnPress: true,
    isDisabled: !state.canDecrement,
    onPressStart: onButtonPressStart
  });
  return {
    groupProps: _babelRuntimeHelpersEsmExtends({
      role: 'group',
      'aria-disabled': isDisabled,
      'aria-invalid': validationState === 'invalid' ? 'true' : undefined
    }, focusWithinProps),
    labelProps,
    inputProps,
    incrementButtonProps,
    decrementButtonProps,
    errorMessageProps,
    descriptionProps
  };
}
//# sourceMappingURL=module.js.map
